'use client';
import Link from "next/link";
import React, { useEffect, useRef, useState } from "react";
import { GrowEfficiency as Icon_GrowEfficiency } from "@/components/customer/icons/GrowEfficiency";
import { GrowLead as Icon_GrowLead } from "@/components/customer/icons/GrowLead";
import { GrowPlanTick as Icon_GrowPlanTick } from "@/components/customer/icons/GrowPlanTick";
import { GrowPlanTickLight as Icon_GrowPlanTickLight } from "@/components/customer/icons/GrowPlanTickLight";
import { GrowSuitHome as Icon_GrowSuitHome } from "@/components/customer/icons/GrowSuitHome";
import { GrowSuiteGrowSvg as Icon_GrowSuiteGrowSvg } from "@/components/customer/icons/GrowSuiteGrowSvg";
import { GrowTeam as Icon_GrowTeam } from "@/components/customer/icons/GrowTeam";
import { ReviewStar as Icon_ReviewStar } from "@/components/customer/icons/ReviewStar";
const SvgIcons = { GrowEfficiency: Icon_GrowEfficiency, GrowLead: Icon_GrowLead, GrowPlanTick: Icon_GrowPlanTick, GrowPlanTickLight: Icon_GrowPlanTickLight, GrowSuitHome: Icon_GrowSuitHome, GrowSuiteGrowSvg: Icon_GrowSuiteGrowSvg, GrowTeam: Icon_GrowTeam, ReviewStar: Icon_ReviewStar };
import { Code, Palette, Database, Zap, Star, ExternalLink, Eye, ChevronLeft, ChevronRight, ArrowRight, Sparkles, Users, Shield, Rocket } from 'lucide-react';

import { m } from 'framer-motion'
import GlobalPartnersCount from "@/components/GlobalPartnersCount";

// Define a custom interface for styles to include objectFit
interface CustomCSSProperties extends React.CSSProperties {
  objectFit?: 'cover' | 'contain' | 'fill' | 'none' | 'scale-down';
}
import growDashboard1 from '../../images/All Employee Data, One Dashboard (2).webp';
import growDashboard2 from '../../images/All Employee Data, One Dashboard.webp'
import growDashboard3 from '../../images/Automate Sales, Boost Conversions.webp'
import growDashboard4 from '../../images/allEmDashboard.webp';

import growDashboard11 from '../../images/Smart Payroll & Compliance.webp';
import growDashboard22 from '../../images/Insights & Self-Service Access.webp'
import growDashboard33 from '../../images/Connect Instantly, Anywhere.webp'
import growDashboard44 from '../../images/Control Access, Empower Teams.webp';



import GoogleImg from '../../images/G_image.webp';



import Image from "next/image";
import TrustedPartners from "../TrustedPartners";
import TestiReviewCommonImages from "./TestiReviewCommonImages";
import { FaFacebook, FaFacebookF } from "react-icons/fa";
import { BsTwitter } from "react-icons/bs";
import mobile from "@/public/images/mobile-img/growsuite-dashbroad-mob.webp"

const Growsuite = () => {
  const faqs = [
    {
      question: "What is GrowSuite?",
      answer: `
      GrowSuite is an all-in-one business growth platform built for startups, small teams, and growing businesses. It combines CRM, HRM, marketing automation, sales pipelines, analytics, and lead management into a single powerful dashboard — helping you run and grow your business faster and smarter.
    `
    },
    {
      question: "How does GrowSuite help my business grow?",
      answer: `
  GrowSuite helps you:
  <ul style="list-style: none; padding-left: 0; margin-top:10px;">
    <li style="display:flex; align-items:flex-start; gap:8px; margin-bottom:8px;">
      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M20 6 9 17l-5-5"/>
      </svg>
      <span>Automate sales and follow-ups</span>
    </li>

    <li style="display:flex; align-items:flex-start; gap:8px; margin-bottom:8px;">
      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M20 6 9 17l-5-5"/>
      </svg>
      <span>Capture and manage leads efficiently</span>
    </li>

    <li style="display:flex; align-items:flex-start; gap:8px; margin-bottom:8px;">
      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M20 6 9 17l-5-5"/>
      </svg>
      <span>Track team performance and tasks</span>
    </li>

    <li style="display:flex; align-items:flex-start; gap:8px; margin-bottom:8px;">
      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M20 6 9 17l-5-5"/>
      </svg>
      <span>Run email and WhatsApp campaigns</span>
    </li>

    <li style="display:flex; align-items:flex-start; gap:8px;">
      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M20 6 9 17l-5-5"/>
      </svg>
      <span>Get real-time insights and reports</span>
    </li>
  </ul>

  It’s designed to reduce manual work and improve productivity across your business functions.
`
    },
    {
      question: "What does the CRM in GrowSuite do?",
      answer: `
  GrowSuite’s CRM brings all your customer and lead data into one place so you can:
  <ul style="list-style: disc; padding-left:20px; margin-top:10px;">
    <li>See every lead’s journey</li>
    <li>Prioritize high-value opportunities</li>
    <li>Automate tasks and reminders</li>
    <li>Close deals faster</li>
  </ul>

  It’s like giving your sales team a smart, organized assistant.
`
    },
    {
      question: "Does GrowSuite include HR management tools?",
      answer: `
      Yes. GrowSuite includes HRM features that help you:
      <ul style=" padding-left:20px; margin-top:10px;">
      <li style="display:flex; align-items:flex-start; gap:8px;">
      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M20 6 9 17l-5-5"/>
      </svg>
      <span>Track attendance and leaves</span>
    </li>
    <li style="display:flex; align-items:flex-start; gap:8px;">
      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M20 6 9 17l-5-5"/>
      </svg>
      <span>Manage payroll and onboarding</span>
    </li>
    <li style="display:flex; align-items:flex-start; gap:8px;">
      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M20 6 9 17l-5-5"/>
      </svg>
      <span>Monitor team performance</span>
    </li>
      
      </ul>
      This makes team management smoother and less time-consuming.
    `
    },
    {
      question: "Can I automate email and WhatsApp campaigns?",
      answer: `
      Absolutely. GrowSuite comes with built-in marketing automation for email and WhatsApp campaigns. You can schedule messages, follow-ups, and personalized communication — letting you stay connected with customers without manual effort.
    `
    },
    {
      question: "Do I need technical skills to use GrowSuite?",
      answer: `
      No. GrowSuite is designed so business users can use it easily — no coding or technical expertise required. Its intuitive dashboards and automation tools help teams focus on growth, not tech hassles.
    `
    },
    {
      question: "Can GrowSuite scale as my business grows?",
      answer: `
      Yes. GrowSuite is scalable and works just as well for small teams as for growing companies. You can add users, upgrade features, and customize automations as your business matures.
    `
    },
    {
      question: "How soon can I start using GrowSuite?",
      answer: `
      After onboarding, you can start setting up your CRM, automations, and dashboards right away. Most businesses start seeing results within the first few weeks of setup.
    `
    },
    {
      question: "Is GrowSuite secure and reliable?",
      answer: `
      Yes. GrowSuite is built with modern web standards and secure infrastructure to protect your business data while you grow.
    `
    },
    {
      question: "Why choose GrowSuite from Vilva Business?",
      answer: `
      Because GrowSuite is not just software — it’s a growth engine tailored to help you automate workflows, nurture leads, manage teams, and improve conversions under one roof. You get a complete ecosystem designed to power your business’s success.
    `
    }
  ];

  const [hoveredCard, setHoveredCard] = useState<number | null>(null);

  const features = [
    {
      icon: <SvgIcons.GrowTeam />,
      title: "Team Productivity ↑",
      description: "Automated HR and task tracking reduces manual work, freeing up time for what matters.",
      stats: "45%"
    },
    {
      icon: <SvgIcons.GrowLead />,
      title: "Lead Conversion Rate ↑",
      description: "AI-based lead scoring and real-time engagement tools ensure faster follow-ups and better-quality conversions.",
      stats: "32%"
    },
    {
      icon: <SvgIcons.GrowEfficiency />,
      title: "Operational Efficiency ↑",
      description: "Manage CRM, HRM, and marketing from one platform — reducing tool-switching and simplifying daily operations.",
      stats: "50%"
    },
    {
      icon: <SvgIcons.GrowTeam />,
      title: "Campaign ROI ↑",
      description: "Run targeted, automated campaigns across email, SMS, and WhatsApp with clear performance tracking to boost returns.",
      stats: "38%"
    }
  ];

  // State to track active item and whether cycling is paused
  const [activeIndex, setActiveIndex] = useState(0);
  const [isPaused, setIsPaused] = useState(false);

  // Array of content items with corresponding images
  const contentItems = [
    {
      title: "All Employee Data, One Dashboard",
      description: "Manage profiles, tasks, attendance, and leaves effortlessly — no more spreadsheets or scattered tools.",
      image: growDashboard1
    },
    {
      title: "End-to-End Employee Lifecycle",
      description: "From onboarding to exit, handle hiring, roles, approvals, and workflows — all in one system.",
      image: growDashboard2
    },
    {
      title: "Smart Payroll & Compliance",
      description: "Automate salaries, generate payslips, and stay fully compliant with built-in payroll processing.",
      image: growDashboard3
    },
    {
      title: "Insights & Self-Service Access",
      description: "Get real-time HR analytics and empower your team with a self-service portal for updates, leave, and payslips.",
      image: growDashboard4
    }
  ];
  const contentItems2 = [
    {
      title: "Capture & Track Every Lead Seamlessly",
      description: "Manage leads and customer interactions in one place with intuitive workflows, smart lead scoring, and flexible sales pipelines.",
      image: growDashboard11
    },
    {
      title: "Automate Sales, Boost Conversions",
      description: "Use AI-driven automation to send follow-ups, reminders, and personalized messages—closing deals faster with less effort.",
      image: growDashboard22
    },
    {
      title: "Connect Instantly, Anywhere",
      description: "Talk to customers directly via built-in WhatsApp integration and collaborate effortlessly with your team using real-time updates.",
      image: growDashboard33
    },
    {
      title: "Control Access, Empower Teams",
      description: "Assign roles, manage permissions, and streamline your sales process with secure user access and tailored pipelines.",
      image: growDashboard44
    }
  ];

  // Handle click on content block
  const handleBlockClick = (index: number) => {
    setActiveIndex(index);
    setIsPaused(true);
    // Resume cycling after 5 seconds
    setTimeout(() => {
      setIsPaused(false);
    }, 5000);
  };

  // Effect for automatic cycling
  useEffect(() => {
    if (isPaused) return;

    const interval = setInterval(() => {
      setActiveIndex((prevIndex) => (prevIndex + 1) % contentItems.length);
    }, 5000); // Change every 5 seconds

    return () => clearInterval(interval); // Cleanup on unmount
  }, [isPaused]);



  return (
    <div className="overflow-hidden">
      <section className="overflow-hidden h-fit bg-[radial-gradient(100.01%_100%_at_52.35%_0%,_#FFF_83.74%,_#BBEAFC_100%)] relative">
        <div className="pt-[60px]">
          <h1 className=" relative z-50 w-full md:w-[700px] mx-auto  text-center font-NeueMontreal text-[40px] md:text-[60px] font-normal leading-[120%] mb-[16px]">AI-Powered CRM & HRM for Business Growth</h1>
          <p className="text-[#374577] px-4 mb-[24px] relative w-full md:w-[50%] mx-auto z-40 text-center font-Schibsted_Grotesk text-[18px] md:text-[20px] font-normal leading-[150%]">Vilva Growsuite is your all-in-one business platform powered by AI. Combining CRM, HRM, marketing, sales, and analytics into one seamless dashboard.</p>

          <div className="flex relative z-40   justify-center items-center gap-2 mt-[32px]">
            <Link data-aos-now
              className="flex h-[52px] whitespace-nowrap w-[180px] relative z-50 px-8 py-4 justify-center items-center rounded-[12px] border-[2px] border-[#6F9CFF] bg-[#EFF4FF] text-[#0048ff] font-Schibsted_Grotesk text-[16px] md:text-lg font-semibold leading-[120%]"
              href="/book-demo"
            >
              Book Free Demo
            </Link>
            <Link data-aos-now
              href="/signin"
              className="flex h-[52px] w-[180px] relative z-50 px-8 py-4 justify-center items-center rounded-[12px] bg-[#064cff] text-white font-Schibsted_Grotesk text-[16px] md:text-lg font-semibold leading-[120%]"
            >
              Get Started
            </Link>
          </div>

        </div>

        <div className="mt-[60px] flex justify-center max-w-7xl mx-auto">
          <Image
            src={getImageUrl("/vilvabusiness/website/products/growsuite/CRM _ Leads.webp")}
            alt="GrowSuite CRM and lead management dashboard"
            width="1200"
            height="675"
            className="md:block hidden w-full h-auto object-contain"
            priority
            decoding="async"
          />

          {/* The file is 721x261; the old 100x675 reserved a tall portrait box for a wide
              screenshot, so the layout shifted once the real image loaded. */}
          <Image
            src={getImageUrl("/vilvabusiness/website/products/growsuite/growsuite-dashbroad-mob.webp")}
            alt="GrowSuite dashboard on mobile"
            width="721"
            height="261"
            className="md:hidden block w-full h-auto object-contain"
            priority
            decoding="async"
          />
        </div>
        <div className="w-[394px] h-[394px] absolute right-[0%] bottom-[1%] bg-[#38F2E5] blur-[250px]" />
        <div className="absolute z-30 w-full h-full top-0">
          <SvgIcons.GrowSuitHome />
        </div>
      </section>

      <TrustedPartners className="relative pt-[30px] md:pt-[40px]" />

      <section className="py-[60px] md:py-[120px] px-4 bg-[#FFF] ">
        <h2 className=" relative w-full  mx-auto  text-center font-NeueMontreal text-[32px] md:text-[48px] leading-[120%] mb-[16px] font-[700]">Effortless HR With Growsuite</h2>
        <p className="text-[#373844] px-0 md:px-4 mb-[40px] relative w-full md:w-[60%] mx-auto z-40 text-center font-Schibsted_Grotesk text-[14px] md:text-[18px] font-normal leading-[150%]">No more juggling spreadsheets or manual tracking. With GrowSuite, everything you need is in one place: employee records, check-ins, tasks, salaries, and more .</p>

        <div className=" md:container bg-[#EDF5FE]  md:!p-[16px] rounded-[24px] flex flex-col md:flex-col lg:flex-row items-start justify-center gap-[16px]">
          {/* Left side - Image with fade transition for desktop */}
          <div className="w-full md:full lg:w-2/5 hidden sm:block relative h-[600px] md:h-[500px] lg:h-[500px]">
            {contentItems.map((item, index) => (
              <Image
                key={index}
                src={item.image}
                alt={item.title || "Grow Image"}
                className={`w-full py-1 h-full md:object-contain lg:object-cover rounded-[8px] absolute top-0 left-0 transition-opacity duration-500 ease-in-out ${activeIndex === index ? 'opacity-100' : 'opacity-0'
                  }`}
              />
            ))}
          </div>

          <div className="w-full md:full lg:w-3/5">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-[16px]">
              {contentItems.map((item, index) => (<React.Fragment key={index}>
                {activeIndex === index && (
                  <div className="h-[300px] sm:h-[500px] mt-[16px] sm:hidden">
                    <Image
                      src={item.image}
                      alt={item.title || "Grow Image"}
                      className="w-full h-full object-contain rounded-[8px] slide-up"
                    />
                  </div>
                )}
                <div key={index} className="flex flex-col px-[16px] md:px-0">
                  <div
                    onClick={() => handleBlockClick(index)}
                    className={`rounded-[8px] h-fit  md:h-[240px] px-[16px] md:px-[24px] py-[24px] transition-all duration-300 cursor-pointer ${activeIndex === index
                      ? 'bg-[radial-gradient(360.25%_138.62%_at_5.57%_2.63%,_#2793FF_0%,_#001165_100%)] shadow-[inset_0px_0px_10px_0px_rgba(25,90,255,0.10)]'
                      : 'bg-white shadow-[inset_0px_0px_10px_0px_rgba(25,90,255,0.10)]'
                      }`}
                  >
                    <p
                      className={`font-Schibsted_Grotesk text-[20px] font-[600] font-semibold leading-[120%] mb-[10px] transition-colors duration-300 ${activeIndex === index ? 'text-white' : 'text-text-[#090D28]'
                        }`}
                    >
                      {item.title}
                    </p>
                    <p
                      className={`font-Schibsted_Grotesk text-[16px] font-normal leading-[150%] transition-colors duration-300 ${activeIndex === index ? 'text-[#E4EAF8]' : 'text-[#373844]'
                        }`}
                    >
                      {item.description}
                    </p>
                  </div>
                  {/* Image for mobile view with slide-up animation */}

                </div>
              </React.Fragment>))}
            </div>
          </div>
          {/* Right side - Content blocks */}
        </div>
      </section>

      <section className="py-[60px] md:py-[120px] bg-[#081328] relative overflow-hidden">
        <div
          className="w-full h-[349px] rounded-[1143px] bg-[#0375FF] opacity-50 animate-blink2 absolute -bottom-[250px] left-1/2 -translate-x-1/2 blur-[100px] flex-shrink-0"
          style={{ willChange: 'opacity' }} />

        <div
          className="w-full md:w-[619px] h-[211px] flex-shrink-0 rounded-[619px] bg-[#B6CEFF] animate-blink2 absolute -bottom-[150px]  left-1/2 -translate-x-1/2 blur-[100px]"
          style={{ willChange: 'opacity' }} />

        <div className="flex container flex-col gap-[16px ] md:flex-row justify-between mb-[40px] md:mb-[96px] items-start">
          <h2 className="text-white w-full md:w-1/2 gap-[16px] font-NeueMontreal text-[36px] md:text-[52px] font-normal leading-[120%]">Built to Simplify, Scale & Succeed</h2>
          <p className="text-white  w-full md:w-[520px]  font-Schibsted_Grotesk text-[16px] md:text-[18px] font-normal leading-[150%]">Growsuite combines CRM, HRM, marketing, and analytics into one powerful AI-driven platform. It automates your daily workflows, delivers real-time insights, and boosts team productivity. Scalable and smart, it grows with your business—no matter the size or stage.</p>
        </div>

        <div className="grid px-4 md:container grid-cols-1 sm:grid-cols-2  gap-[32px] lg:grid-cols-4">
          {features.map((feature, index) => {
            const Icon = feature.icon;
            const isHovered = hoveredCard === index;

            return (
              <div
                key={index}
                onMouseEnter={() => setHoveredCard(index)}
                onMouseLeave={() => setHoveredCard(null)}
                className="relative z-50 group overflow-hidden"
                style={{ animationDelay: `${index * 100}ms` }}
              >
                <div className="rounded-[0px_24px] h-full relative z-50 overflow-hidden border-[0.8px] border-none bg-gradient-to-b from-[rgba(155,199,255,0.20)] to-[rgba(117,221,255,0.20)] backdrop-blur-[10px] p-6">
                  <div className="rounded-[4px] w-fit mb-[10px] bg-[#0A518F] p-1">
                    {Icon}
                  </div>
                  <p className="text-[48px] mb-1 font-normal leading-[120%] text-[#4BABFF] font-NeueMontreal">
                    {feature.stats}
                  </p>
                  <p className="text-[20px] mb-4 font-normal leading-[100%] text-white font-Schibsted_Grotesk">
                    {feature.title}
                  </p>
                  <p className="text-[14px] font-normal leading-[150%] text-[#8BB4DF] font-Schibsted_Grotesk">
                    {feature.description}
                  </p>
                </div>
                <div className="absolute inset-0 rounded-[0px_24px] bg-gradient-to-r from-transparent via-white/10 to-transparent translate-x-[-100%] group-hover:translate-x-[100%] transition-transform duration-1000 " />
              </div>
            );
          })}
        </div>


      </section>


      <section className="py-[60px] md:py-[120px] px-4 bg-[#EDF5FE] ">
        <h2 className=" relative w-full  mx-auto  text-center font-NeueMontreal text-[32px] md:text-[48px] font-normal leading-[120%] mb-[16px]">Smarter CRM for Faster Growth</h2>
        <p className="text-[#373844] px-0 md:px-4 mb-[40px] relative w-full md:w-[55%] mx-auto z-40 text-center font-Schibsted_Grotesk text-[16px] md:text-[20px] font-normal leading-[150%]">Automate follow-ups, track leads, and chat via WhatsApp — all in one AI-powered CRM. Sell smarter and scale faster with lead scoring, custom pipelines, and secure team access.</p>



        <div className=" md:container bg-[#EDF5FE]  border-[2px] border-[#fff] md:!p-[16px] rounded-[24px] flex flex-col md:flex-col-reverse lg:flex-row items-start justify-center gap-[16px]">
          {/* Left side - Image with fade transition for desktop */}


          <div className="w-full md:full lg:w-3/5">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-[16px]">
              {contentItems2.map((item, index) => (<React.Fragment key={index}>
                {activeIndex === index && (
                  <div className="h-[300px] sm:h-[500px] mt-[16px] sm:hidden">
                    <Image
                      src={item.image}
                      alt={item.title || 'Grow Image'}
                      className="w-full h-full object-contain rounded-[8px] slide-up"
                    />
                  </div>
                )}
                <div key={index} className="flex flex-col px-[16px] md:px-0">
                  <div
                    onClick={() => handleBlockClick(index)}
                    className={`rounded-[8px] h-fit  md:h-[240px] px-[16px] md:px-[24px] py-[24px] transition-all duration-300 cursor-pointer ${activeIndex === index
                      ? 'bg-[radial-gradient(360.25%_138.62%_at_5.57%_2.63%,_#2793FF_0%,_#001165_100%)] shadow-[inset_0px_0px_10px_0px_rgba(25,90,255,0.10)]'
                      : 'bg-white shadow-[inset_0px_0px_10px_0px_rgba(25,90,255,0.10)]'
                      }`}
                  >
                    <p
                      className={`font-Schibsted_Grotesk  text-[20px] font-semibold leading-[120%] mb-[10px] transition-colors duration-300 ${activeIndex === index ? 'text-white' : 'text-text-[#090D28]'
                        }`}
                    >
                      {item.title}
                    </p>
                    <p
                      className={`font-Schibsted_Grotesk text-[16px] font-normal leading-[150%] transition-colors duration-300 ${activeIndex === index ? 'text-[#E4EAF8]' : 'text-[#373844]'
                        }`}
                    >
                      {item.description}
                    </p>
                  </div>
                  {/* Image for mobile view with slide-up animation */}

                </div>
              </React.Fragment>))}
            </div>
          </div>
          {/* Right side - Content blocks */}

          <div className="w-full md:full lg:w-2/5 hidden sm:block relative h-[300px] md:h-[500px]">
            {contentItems2.map((item, index) => (
              <Image
                key={index}
                src={item.image}
                alt={item.title || "Grow Suite Image"}
                className={`w-full h-full md:object-contain lg:object-cover rounded-[8px] absolute top-0 left-0 transition-opacity duration-500 ease-in-out ${activeIndex === index ? 'opacity-100' : 'opacity-0'
                  }`}
              />
            ))}
          </div>
        </div>




      </section>

      <section className="relative">
        <GrowSmarter />

        <SvgIcons.GrowSuiteGrowSvg
          className="absolute bottom-0 left-1/2 -translate-x-1/2 h-full w-[2000px]"
        />


      </section>

      <section className="px-4 md:px-0 md:container md:py-[120px] py-[60px]">
        <h2 className="text-text-[#090D28] relative z-30 text-center text-[28px] mb-[16px] md:mb-[60px] md:text-[40px] font-normal leading-[120%] font-NeueMontreal"
        >Simple Plans for Every Stage of Growth</h2>

        {/* <p className="text-[#373844] text-center hidden w-full !md:w-[551px] text-[16px] font-normal leading-[150%] font-Schibsted_Grotesk bg-yellow-700"
        >Whether you're a startup or scaling fast, Growsuite has a plan that fits your needs — with powerful features and zero fluff.</p> */}

        <p className="text-[#8B9CB3] text-center md:hidden block mt-[16px]  text-[12px] font-normal leading-[100%] font-Schibsted_Grotesk mb-[36px]">*GST Charges Apply</p>

        <div>
          <div className="flex flex-col md:flex-col lg:flex-row gap-[24px] md:gap-[40px] justify-center ">

            <div className="rounded-[16px] relative bg-gradient-to-b from-[#004AAB] to-[#3F92FF] p-[16px] md:w-[320px] w-full">
              <div
                className="
    inline-flex
    px-[20px] py-[4px]
    justify-center items-center gap-[10px]
    text-[#102D1B] text-[12px] font-normal leading-[120%] font-Schibsted_Grotesk
    rounded-b-[12px]
    bg-gradient-to-r from-[#FFC42E] via-[#FFEF3D] to-[#FFC42E]
    absolute top-0 left-1/2 -translate-x-1/2
    overflow-hidden 
  "
              >
                <div className="relative w-full h-full">
                  <span
                    className="
        absolute -top-2 -left-[150px] -translate-y-1/2
        w-[5px] h-[300px]
        bg-white 
        skew-x-[-20deg]
        animate-crossSlide
        blur-sm
      "
                  ></span>
                  <span className="relative z-50 text-[12px] font-Schibsted_Grotesk">Best Value</span>
                </div>
              </div>




              <div className="flex  items-center my-4 justify-between">
                <p className="text-white font-NeueMontreal text-[32px] font-normal leading-[100%]">Rs.8999</p>
                <div className="px-[12px] !py-[4px] !m-0  text-white text-center text-[12px] font-normal  font-Schibsted_Grotesk rounded-[14px] border border-[#3482E6] bg-[#176FE1]"
                >Growsuite = CRM + HRM</div>

              </div>
              <p className="text-[#BDD6F7] text-[12px] font-normal leading-[100%] font-Schibsted_Grotesk"
              >Per Month - Billing Anually</p>

              <p className="inline-flex mt-4 items-center justify-center px-[24px] py-[12px] gap-[10px] 
text-[#014BAC] text-[16px] font-semibold leading-[100%] font-Schibsted_Grotesk 
rounded-[24px] border-[2px] border-[#9FC9F2] bg-white 
transition-all duration-300 ease-in-out 
hover:bg-[#014BAC] hover:text-white mb-4">Get Plan Now</p>

              <div className="w-full mb-[24px] h-[0.8px] !bg-[#307DE1]" />
              <ul>
                <li className="text-white text-[14px] font-normal leading-[100%] font-Schibsted_Grotesk mb-[16px] flex items-center gap-2"><SvgIcons.GrowPlanTickLight /> Includes all CRM + HRM features</li>
                <li className="text-white text-[14px] font-normal leading-[100%] font-Schibsted_Grotesk mb-[16px] flex items-center gap-2"><SvgIcons.GrowPlanTickLight /> Multi-channel marketing automation </li>
                <li className="text-white text-[14px] font-normal leading-[100%] font-Schibsted_Grotesk mb-[16px] flex items-center gap-2"><SvgIcons.GrowPlanTickLight /> Performance dashboards </li>
                <li className="text-white text-[14px] font-normal leading-[100%] font-Schibsted_Grotesk mb-[16px] flex items-center gap-2"><SvgIcons.GrowPlanTickLight /> Includes all CRM + HRM features</li>
                <li className="text-white text-[14px] font-normal leading-[100%] font-Schibsted_Grotesk mb-[16px] flex items-center gap-2"><SvgIcons.GrowPlanTickLight />  Priority support & updates</li>
                <li className="text-white text-[14px] font-normal leading-[100%] font-Schibsted_Grotesk mb-[16px] flex items-center gap-2"><SvgIcons.GrowPlanTickLight /> Integration-ready modules </li>
                <li className="text-white text-[14px] font-normal leading-[100%] font-Schibsted_Grotesk mb-[16px] flex items-center gap-2"><SvgIcons.GrowPlanTickLight />  Lead capture & tracking</li>
                <li className="text-white text-[14px] font-normal leading-[100%] font-Schibsted_Grotesk mb-[16px] flex items-center gap-2"><SvgIcons.GrowPlanTickLight />  Custom sales pipelines</li>
                <li className="text-white text-[14px] font-normal leading-[100%] font-Schibsted_Grotesk mb-[16px] flex items-center gap-2"><SvgIcons.GrowPlanTickLight /> WhatsApp & email integration </li>
                <li className="text-white text-[14px] font-normal leading-[100%] font-Schibsted_Grotesk mb-[16px] flex items-center gap-2"><SvgIcons.GrowPlanTickLight /> Employee database & self-service</li>
                <li className="text-white text-[14px] font-normal leading-[100%] font-Schibsted_Grotesk  flex items-center gap-2"><SvgIcons.GrowPlanTickLight /> Onboarding workflows</li>
              </ul>
            </div>


            <div>
              <p className="text-[#373844] hidden md:block w-full md:w-[541px] text-[18px] font-normal leading-[150%] font-Schibsted_Grotesk"
              >Whether you're a startup or scaling fast, Growsuite has a plan that fits your needs — with powerful features and zero fluff.</p>

              <p className="text-[#8B9CB3] hidden md:block mt-[16px] text-[12px] font-normal leading-[100%] font-Schibsted_Grotesk mb-[36px]">*GST Charges Apply</p>

              <div className="flex flex-col sm:flex-row gap-[40px] items-start">

                <div className="rounded-[16px] relative border border-[#024CAD] p-[16px] w-full md:w-[320px]">



                  <div className="flex  items-center my-4 justify-between">
                    <p className="text-text-[#090D28] font-NeueMontreal text-[32px] font-normal leading-[100%]">Rs.3999</p>
                    <div className=" !m-0 px-[12px] py-[4px] 
text-[#024CAD] text-center text-[14px] font-normal leading-[100%] font-Schibsted_Grotesk
rounded-[14px] border border-[#D3E2F5] bg-[#E7EFF8] flex items-center justify-center">CRM</div>

                  </div>
                  <p className="text-[#4C678A] text-[12px] font-normal leading-[100%] font-Schibsted_Grotesk"
                  >Per Month - Billing Anually</p>

                  <p className="inline-flex mt-4 items-center justify-center px-[24px] py-[12px] gap-[10px] 
text-[#fff] text-[16px] font-normal leading-[100%] font-Schibsted_Grotesk 
rounded-[24px] border-[2px] border-[#9FC9F2] bg-[#024CAD] 
transition-all duration-300 ease-in-out 
hover:bg-[#fff] hover:text-[#024CAD] mb-4">Get Plan Now</p>

                  <div className="w-full mb-[24px] h-[0.8px] bg-[#EAEDF0]" />
                  <ul>
                    <li className="text-text-[#090D28] text-[14px] font-normal leading-[100%] font-Schibsted_Grotesk mb-[16px] flex items-center gap-2"><SvgIcons.GrowPlanTick /> Lead capture & tracking </li>
                    <li className="text-text-[#090D28] text-[14px] font-normal leading-[100%] font-Schibsted_Grotesk mb-[16px] flex items-center gap-2"><SvgIcons.GrowPlanTick /> AI-based lead scoring</li>
                    <li className="text-text-[#090D28] text-[14px] font-normal leading-[100%] font-Schibsted_Grotesk mb-[16px] flex items-center gap-2"><SvgIcons.GrowPlanTick /> Custom sales pipelines </li>
                    <li className="text-text-[#090D28] text-[14px] font-normal leading-[100%] font-Schibsted_Grotesk mb-[16px] flex items-center gap-2"><SvgIcons.GrowPlanTick /> Includes all CRM + HRM features</li>
                    <li className="text-text-[#090D28] text-[14px] font-normal leading-[100%] font-Schibsted_Grotesk mb-[16px] flex items-center gap-2"><SvgIcons.GrowPlanTick /> WhatsApp & email integration</li>
                    <li className="text-text-[#090D28] text-[14px] font-normal leading-[100%] font-Schibsted_Grotesk mb-[16px] flex items-center gap-2"><SvgIcons.GrowPlanTick />Sales automation workflows </li>
                    <li className="text-text-[#090D28] text-[14px] font-normal leading-[100%] font-Schibsted_Grotesk mb-[16px] flex items-center gap-2"><SvgIcons.GrowPlanTick /> Real-time customer analytics</li>
                    <li className="text-text-[#090D28] text-[14px] font-normal leading-[100%] font-Schibsted_Grotesk  flex items-center gap-2"><SvgIcons.GrowPlanTick /> Up to 10 users</li>

                  </ul>
                </div>

                <div className="rounded-[16px] relative border border-[#024CAD] p-[16px] w-full md:w-[320px]">



                  <div className="flex  items-center my-4 justify-between">
                    <p className="text-text-[#090D28] font-NeueMontreal text-[32px] font-normal leading-[100%]">Rs.4999</p>
                    <div className=" !m-0 px-[12px] py-[4px]  
text-[#024CAD] text-center text-[14px] font-normal leading-[100%] font-Schibsted_Grotesk 
rounded-[14px] border border-[#D3E2F5] bg-[#E7EFF8]">HRM</div>

                  </div>
                  <p className="text-[#4C678A] text-[12px] font-normal leading-[100%] font-Schibsted_Grotesk"
                  >Per Month - Billing Anually</p>

                  <p className="inline-flex mt-4 items-center justify-center px-[24px] py-[12px] gap-[10px] 
text-[#fff] text-[16px] font-normal leading-[100%] font-Schibsted_Grotesk 
rounded-[24px] border-[2px] border-[#9FC9F2] bg-[#024CAD] 
transition-all duration-300 ease-in-out 
hover:bg-[#fff] hover:text-[#024CAD] mb-4">Get Plan Now</p>

                  <div className="w-full mb-[24px] h-[0.8px] bg-[#EAEDF0]" />
                  <ul>
                    <li className="text-text-[#090D28] text-[14px] font-normal leading-[100%] font-Schibsted_Grotesk mb-[16px] flex items-center gap-2"><SvgIcons.GrowPlanTick /> Employee database & self-service </li>
                    <li className="text-text-[#090D28] text-[14px] font-normal leading-[100%] font-Schibsted_Grotesk mb-[16px] flex items-center gap-2"><SvgIcons.GrowPlanTick /> Attendance & leave tracking</li>
                    <li className="text-text-[#090D28] text-[14px] font-normal leading-[100%] font-Schibsted_Grotesk mb-[16px] flex items-center gap-2"><SvgIcons.GrowPlanTick /> Automated payroll processing</li>
                    <li className="text-text-[#090D28] text-[14px] font-normal leading-[100%] font-Schibsted_Grotesk mb-[16px] flex items-center gap-2"><SvgIcons.GrowPlanTick /> Role-based access control</li>
                    <li className="text-text-[#090D28] text-[14px] font-normal leading-[100%] font-Schibsted_Grotesk mb-[16px] flex items-center gap-2"><SvgIcons.GrowPlanTick /> Onboarding workflows</li>
                    <li className="text-text-[#090D28] text-[14px] font-normal leading-[100%] font-Schibsted_Grotesk mb-[16px] flex items-center gap-2"><SvgIcons.GrowPlanTick />HR analytics dashboard </li>
                    <li className="text-text-[#090D28] text-[14px] font-normal leading-[100%] font-Schibsted_Grotesk mb-[16px] flex items-center gap-2"><SvgIcons.GrowPlanTick /> WhatsApp & email integration</li>
                    <li className="text-text-[#090D28] text-[14px] font-normal leading-[100%] font-Schibsted_Grotesk  flex items-center gap-2"><SvgIcons.GrowPlanTick />Up to 10 users</li>

                  </ul>
                </div>

              </div>
            </div>

          </div>
        </div>
      </section>


      <section className="bg-[#01001E]  py-[60px] md:py-[120px] relative overflow-hidden">
        <h2 className="text-white z-50 relative text-center text-[32px] md:text-[48px] font-extrabold leading-[120%] font-NeueMontreal">We Make for Your Team  </h2>
        <p className="text-[#c4c4c4] z-50 relative text-center text-[16px] md:text-[18px] font-normal leading-[150%] font-Schibsted_Grotesk py-4">Our team ensures timely results without compromising quality</p>
        <section className="flex items-center justify-center gap-3 ">
          <TestiReviewCommonImages />
          <div>
            <a href="https://maps.app.goo.gl/wxZr7ckDhrWnVbx27" aria-label="Review" className='text-white' target='_blank'> <p className="text-[#F5F7FF] text-center font-LatinkaRegular m-0 p-0 pb-[6px] text-sm font-normal leading-[120%] flex gap-1 items-center"><Image className="w-6" src={getImageUrl("/vilvabusiness/website/common/homepage/google-img.webp")} alt="GoogleImg" width={50} height={50}  />  Google Reviews</p></a>
            <div className="flex items-center gap-2 text-white">
              4.7
              <div className="flex items-center gap-2">
                <SvgIcons.ReviewStar />
                <SvgIcons.ReviewStar />
                <SvgIcons.ReviewStar />
                <SvgIcons.ReviewStar />
                <SvgIcons.ReviewStar />
              </div>
            </div>
          </div>
        </section>
        <div className="relative z-50 pb-0 md:pb-[120px]">
          <StatsSection />

        </div>


        <div className=" px-4 mt-[120px] md:container">
          <div className="block md:flex items-center justify-center">
            <div className="w-full md:w-2/5">
              <p className=" relative z-50
    w-full md:w-[300px] lg:w-[483px]
    text-[22px] lg:text-[32px]
    font-semibold leading-[140%]
    font-Schibsted_Grotesk
    bg-gradient-to-b from-white to-[#88A4FF]
    bg-clip-text text-transparent
  ">Join 200+ businesses using Growsuite to simplify sales, streamline HR, and scale faster — all with the power of AI.</p>

              <a className="inline-flex mt-[24px]  z-50 items-center justify-center 
px-[32px] py-[16px] h-[52px] flex-shrink-0 
bg-[#195AFF] rounded-[8px] 
text-white text-[20px] relative font-normal leading-[120%] font-Schibsted_Grotesk"
                href="#" target="_blank">Get Instant Access</a>
            </div>

            <div className="w-full z-50 relative md:w-3/5">

            </div>
          </div>

        </div>
        <div className="w-full">
          <div className="relative lg:absolute bottom-0 z-30 right-0 mt-[60px] lg:mt-[0px]">
            <div className="relative top-[90px]">

              <div>
                <RotatingSocialIcons />
              </div>
            </div>
          </div>
        </div>

        <div className=" absolute bottom-0 w-full h-[349px] flex-shrink-0
    [background:radial-gradient(275.71%_157.35%_at_64.69%_178.51%,#0093F5_0%,#01001E_100%)]"/>

      </section>

      <section className="pb-[60px] md:pb-[120px] px-4 md:px-0 md:container">
        {/* <h2 className="text-[#090D28] text-center md:text-[] text-[32px] w-full mx-auto whitespace-normal md:whitespace-nowrap md:text-[40px] font-extrabold leading-[120%] font-LatinkaBold">
          Your questions Our Answers
        </h2> */}
        <FaqSection faqs={faqs} />
      </section>

    </div>
  );
};

export default Growsuite;





import { GrowSmarter } from "./GrowSmarter";
import RotatingSocialIcons from "./GrowsuiteRotatingSocialIcons";
import FaqSection from "../FaqSection";
import { getImageUrl } from "@/lib/imageUrl";
import StatsSection from "../StatusSection";








